import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { LoginService } from './Service';
import { setErrorResponse, setSuccessResponse } from '../responses/Action';
import * as Constants from '../../utils/constants';

/**
 * 
 * @param {Objeto completo contendo login} loginObject 
 */
export const logoutResponse = loginObject => ({
    type: ActionType.LOGOUT_RESPONSE,
    loginObject
});

export const loginResponse = loginObject => ({
    type: ActionType.LOGIN_RESPONSE,
    loginObject
});

export function efetuarLoginAction(login) {
    return async function (dispatch) {
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());
        try {
            let loginObject = await LoginService.postLogin(login);

            await dispatch(setSuccessResponse(Constants.DESCRICAO_SUCCESS));
            await dispatch(loginResponse(loginObject));

            window.sessionStorage.setItem("token", loginObject.access);
            window.sessionStorage.setItem("username", login.username);

            return loginObject;
        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }
    }
}

export function efetuarLogoutAction() {
    return async function (dispatch) {
        await dispatch(setSuccessResponse(null));
        await dispatch(setErrorResponse(null));
        await dispatch(ApiCallBeginAction());
        try {
            let loginObject = null;
            await dispatch(loginResponse(loginObject));
            window.sessionStorage.removeItem("token");
            window.sessionStorage.removeItem("username");

        } catch (error) {
            dispatch(setErrorResponse(error));
            throw error;
        }
    }
}

